// import {BASE_DATA_URL} from '../../envs.js';
import {MAP_PROJECTION} from './constants';
import VectorSource from "ol/source/Vector.js";
import VectorLayer from "ol/layer/Vector.js";
import Style from "ol/style/Style.js";
import Stroke from "ol/style/Stroke.js";

import {ol as flatgeobuf} from "flatgeobuf";

const styleNear = new Style({
  stroke: new Stroke({
    color: "#078065",
    width: 4.5,
  }),
});

const styleFar = new Style({
  stroke: new Stroke({
    color: "#078065",
    width: 3.5,
  }),
});

export class CrosscountryNetworkLayer extends VectorLayer {
  constructor(options) {

    const baseDataUrl = options.baseDataUrl;

    super(
      Object.assign(
        {
          style: (feature, resolution) => {
            if (resolution <= 10) {
              return styleNear;
            }
            if (resolution <= 50) {
              return styleFar;
            }
            return null;
          },
          source: new VectorSource({
            loader: async function() {
              const response = await fetch(
                `${baseDataUrl}/crosscountry_import/crosscountry.2056.simple_5.fgb`
              );
              const features = [];
              for await (const feature of flatgeobuf.deserialize(response.body)) {
                feature.getGeometry().transform('EPSG:2056', MAP_PROJECTION);
                features.push(feature);
              }
              this.addFeatures(features);
            },
          }),
        },
        options
      )
    );
  }
}
